import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2f3afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Container" }, null, -1))

import ToolTip from '@/components/ToolTip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTipLabel',
  props: {
    information: { type: Boolean },
    warning: { type: Boolean },
    tip: {},
    text: {},
    forId: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "ToolTipContainer",
    for: _ctx.forId
  }, [
    _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
    _hoisted_2,
    _createVNode(ToolTip, {
      style: {"margin":"auto auto auto 5px"},
      information: _ctx.information,
      warning: _ctx.warning,
      tip: _ctx.tip
    }, null, 8, ["information", "warning", "tip"])
  ], 8, _hoisted_1))
}
}

})